import { render, staticRenderFns } from "./CheckoutProcess.vue?vue&type=template&id=647c5cf8&scoped=true&"
import script from "./CheckoutProcess.vue?vue&type=script&lang=js&"
export * from "./CheckoutProcess.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutProcess.vue?vue&type=style&index=0&id=647c5cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c5cf8",
  null
  
)

export default component.exports